module.exports = __webpack_public_path__ + "static/img/win.77c5966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xz/win.png
// module id = VQlp
// module chunks = 1